var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtisteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4702 12.703L28.3982 0H25.8086L16.3198 11.0298L8.74111 0H0L11.4605 16.679L0 30H2.58974L12.6102 18.3522L20.6138 30H29.3549L17.4695 12.703H17.4702ZM13.9232 16.8259L12.762 15.1651L3.52286 1.94952H7.50055L14.9566 12.6149L16.1178 14.2758L25.8098 28.1391H21.8321L13.9232 16.8266V16.8259Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisteX);
export default __webpack_public_path__ + "static/media/artiste_x.45db7b55778a58304720647330ff2077.svg";
export { ForwardRef as ReactComponent };